import CreateNuageCloudSubnetForm from '../components/create-nuage-cloud-subnet-form';

ManageIQ.component.addReact('CreateNuageCloudSubnetForm', CreateNuageCloudSubnetForm);
